<app-nav-menu *ngIf="isLoggedIn"></app-nav-menu>

<app-login *ngIf="!isLoggedIn"></app-login>

<!-- <router-outlet></router-outlet> -->

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white;">Aguarde...</p>
</ngx-spinner>

<ngx-spinner
  name="osSpinner"
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white;">Carregando O.S...</p>
</ngx-spinner>

<ngx-spinner
  name="tablesSpinner"
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white;">Atualizando Tabelas...</p>
</ngx-spinner>

<ngx-spinner
  name="mailSpinner"
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white;">Enviando E-mail...</p>
</ngx-spinner>
